import {create} from 'zustand';
import {UseExitFlowModalStoreProps} from './types';

export const useExitFlowModalStore = create<UseExitFlowModalStoreProps>(set => ({
	open: false,
	setOpen: open => set({open}),
	reset: () => set({open: false}),
}));
